import shopifyEnterpriseGenericDefaults from '../shopify-enterprise-generic/config.js';
import { ConvermaxProductForm } from './custom-elements.js';
import {
  getYmmTabPreselection,
  initYmmTabs,
  ymmTabsOnVehicleSelected,
  ymmTabsResponseHandler,
} from './ymm-tabs.js';

const upsizeDownsizeFacetPanelFields = ['wheel_tire_diameter', 'FrontRear', 'tire_size'];

shopifyEnterpriseGenericDefaults.Widgets.forEach((w) => {
  if (w.name === 'FilterChips' || w.name === 'Facets') {
    if (w.ignoreFields) {
      w.ignoreFields.push(...upsizeDownsizeFacetPanelFields);
    } else {
      w.ignoreFields = upsizeDownsizeFacetPanelFields;
    }
  }
  return w;
});

const selectedStoreId = window.Titan?.utils?.getLocalStorageByKey('selectedStoreId');
const {
  priceBaseValue,
  phone: selectedStorePhone,
  storeName: selectedStoreName,
} = window.Titan?.utils?.getFormattedStoreData(
  window.Titan?.utils?.getLocalStorageByKey('selectedStoreData'),
) || {};

const isOnHomePage = window.Convermax.Shopify?.getPageType() === 'home';

const collectionsPageUrl = window.Convermax.Shopify?.getCollectionsPageUrl() ?? '/collections';
const searchPageUrl = window.Convermax.Shopify?.getSearchPageUrl() ?? '/pages/search';

const tiresCollectionUrl = `${collectionsPageUrl}/tires`;
const wheelsCollectionUrl = `${collectionsPageUrl}/wheels`;
const isOnCategoryListPage = window.document.querySelector('#cm-collection-list');

const baseFitmentFields = shopifyEnterpriseGenericDefaults.fitmentSearch.baseFields;
const wheelsFields = shopifyEnterpriseGenericDefaults.Widgets.find((w) => w.name === 'FacetBarWheels').fields;
const tiresFields = shopifyEnterpriseGenericDefaults.Widgets.find((w) => w.name === 'FacetBarTires').fields;

window.Convermax.hasWheelTireDropdownSelectionOrQuery = () => {
  const searchRequest = window.Convermax.getSearchRequest();
  return (
    searchRequest.query ||
    tiresFields.every((f) => searchRequest.selection.find((s) => s.field === f)) ||
    wheelsFields.every((f) => searchRequest.selection.find((s) => s.field === f))
  );
};

const isAllProductsWheels = () => {
  return (
    window.location.pathname === searchPageUrl ||
    window.document.querySelector('#vehicle-ymm-tabs .cm_tabs_content .cm_tire-search')?.children.length === 0
  );
};
const isAllProductsTires = () => {
  return (
    window.location.pathname === searchPageUrl ||
    window.document.querySelector('#vehicle-ymm-tabs .cm_tabs_content .cm_wheel-search')?.children.length ===
      0
  );
};

const defaultRequestExtra = { ...shopifyEnterpriseGenericDefaults.SearchRequestDefaults.extra };
if (selectedStoreId) {
  defaultRequestExtra.selectedStoreId = selectedStoreId;
}
if (priceBaseValue) {
  defaultRequestExtra.priceBaseValue = priceBaseValue;
}

const availabilityUserTimeZone = window.Intl?.DateTimeFormat().resolvedOptions().timeZone;
if (availabilityUserTimeZone) {
  defaultRequestExtra._availabilityUserTimeZone = availabilityUserTimeZone;
}

window.Convermax.isStoreSelected = !!selectedStoreId;
window.Convermax.selectedStoreName = selectedStoreName;

// Normalize phone number the same way as Tire Discounters theme code:
// "+1 (513) 271-4422" / "1-513-271-4422" -> "5132714422"
const cleanedSelectedStorePhone = selectedStorePhone ? `${selectedStorePhone}`.replace(/\D/g, '') : null;
const normalizedSelectedStorePhone =
  cleanedSelectedStorePhone &&
  cleanedSelectedStorePhone.length === 11 &&
  cleanedSelectedStorePhone.startsWith('1')
    ? cleanedSelectedStorePhone.substring(1)
    : cleanedSelectedStorePhone;

// Keep tel: href close to the original theme behavior:
// remove spaces/dashes/brackets, but keep "+" if it exists.
window.Convermax.selectedStorePhone = selectedStorePhone
  ? `1${selectedStorePhone}`.trim().replace(/[^+\d]/g, '')
  : null;
// Format text value only when we have a valid 10-digit US phone number.
// Otherwise fallback to the original value instead of hiding the phone completely.
window.Convermax.selectedStorePhoneText =
  normalizedSelectedStorePhone && normalizedSelectedStorePhone.length === 10
    ? `(${normalizedSelectedStorePhone.slice(0, 3)}) ${normalizedSelectedStorePhone.slice(3, 6)}-${normalizedSelectedStorePhone.slice(6)}`
    : selectedStorePhone || null;

const staggeredSearchFields = ['FrontRear', 'FrontProductID', 'RearProductID'];
window.Convermax.isOnStaggeredSearch = () =>
  staggeredSearchFields.some((f) => window.location.href.includes(f)) ||
  !!window.Convermax.getSearchResponse()?.facets.get('FrontRear');

const noWheelImageSrc =
  'https://cdn.shopify.com/s/files/1/0912/8083/4875/files/noImageWheel.png?v=1753883124';
const noTireImageSrc = 'https://cdn.shopify.com/s/files/1/0912/8083/4875/files/noImageTire.png?v=1753883125';
window.Convermax.getProductImage = (fitmentType) => {
  return fitmentType === 'Wheel' ? noWheelImageSrc : fitmentType === 'Tire' ? noTireImageSrc : null;
};

window.Convermax.handleQtySelector = (target, formatPrice) => {
  const quantitySelectorInput = target.closest('.qty-input').querySelector('.qty-input__input');
  const addToCartForm = target.closest('form');
  const quantityFormInput = addToCartForm.querySelector('input[name="quantity"]');

  const currentQty = +quantitySelectorInput.getAttribute('value');
  if (
    // add max 7 products to cart per client request
    (target.classList.contains('btn--plus') && currentQty === 7) ||
    (target.classList.contains('btn--minus') && currentQty === 1)
  ) {
    return;
  }

  const newQty = target.classList.contains('btn--plus') ? currentQty + 1 : currentQty - 1;

  quantitySelectorInput.setAttribute('value', newQty);
  quantitySelectorInput.value = newQty;
  quantityFormInput.value = newQty;

  const priceContainer = target.closest('.card__info')?.querySelector('.titan-price');
  const regionalPrice = priceContainer?.getAttribute('data-regional-price');

  if (!regionalPrice) {
    return;
  }

  target
    .closest('.card__info')
    ?.querySelectorAll('.titan-info-list li')
    .forEach((el) => {
      el.classList.toggle('greenCheck', newQty >= 4);
      el.classList.toggle('redX', newQty < 4);
    });

  const leftPriceContainer = priceContainer.querySelector('.titan-left-price');
  const priceAmountContainer = leftPriceContainer.querySelector('.titan-price-amount');
  const compareAtPriceContainer = priceContainer.querySelector('.titan-right-price');

  const productQuantity = quantityFormInput.value;

  if (productQuantity >= 4) {
    const percentageDiscount = priceContainer.getAttribute('data-percentage-discount');
    const dollarsDiscount = priceContainer.getAttribute('data-dollars-discount');

    const discountAmount = +percentageDiscount + +dollarsDiscount / productQuantity;
    const newPrice = +regionalPrice - discountAmount;

    if (discountAmount > 0) {
      leftPriceContainer.classList.add('titan-price-green');
      priceAmountContainer.textContent = formatPrice(newPrice);
      compareAtPriceContainer.classList.remove('cm_hide');
    }
  } else {
    compareAtPriceContainer.classList.add('cm_hide');
    leftPriceContainer.classList.remove('titan-price-green');
    priceAmountContainer.textContent = formatPrice(regionalPrice);
  }
};

const updateCallback = () => {
  // close mobile main menu (when vehicle was selected in garage)
  window.document
    .querySelector('main-menu.main-menu details.main-menu__disclosure.is-open summary.main-menu__toggle')
    ?.click();

  const isOnStaggeredSearch = window.Convermax.isOnStaggeredSearch();

  // revert product card qty selector and price to initial state
  [...window.document.querySelectorAll('.cm_SearchResult .card--product')].forEach((product) => {
    const quantitySelectorInput = product.querySelector('.qty-input__input');
    if (!quantitySelectorInput) {
      return;
    }

    const priceContainer = product.querySelector('.titan-price');
    const initialPrice = priceContainer.getAttribute('data-initial-price');

    priceContainer.querySelector('.titan-left-price .titan-price-amount').textContent = initialPrice;
    if (priceContainer.getAttribute('data-initial-discount') === '0' || isOnStaggeredSearch) {
      priceContainer.querySelector('.titan-right-price').classList.add('cm_hide');
    } else {
      priceContainer.querySelector('.titan-right-price').classList.remove('cm_hide');
      priceContainer.querySelector('.titan-left-price').classList.add('titan-price-green');
    }

    const quantityFormInput = product.querySelector('form > input[name="quantity"]');

    const defaultQuantity = isOnStaggeredSearch ? 2 : 4;
    quantitySelectorInput.setAttribute('value', defaultQuantity);
    quantitySelectorInput.value = defaultQuantity;
    quantityFormInput.value = defaultQuantity;
  });
};

function responseHandler(response, onInit) {
  const homeYmmBar = window.document.querySelector('.cm-home-ymm');
  const collectionFitmentType = response?.Extra?.collectionFitmentType;

  if (!collectionFitmentType || !homeYmmBar || !onInit) {
    return response;
  }

  ymmTabsResponseHandler(collectionFitmentType);

  return response;
}

window.Convermax.addStaggeredPackagesHandler = (product) => (e) => {
  const { href, pathname } = window.location;
  const variantId = product.variant_ids?.[0];
  const productId = product.id;
  const badges = product._badges;

  const isFront = href.includes('FrontRear/Front') || badges?.includes('Front');
  const isRear = href.includes('FrontRear/Rear') || badges?.includes('Rear');
  if ((!isFront && !isRear) || href.includes('FrontProductID') || href.includes('RearProductID')) {
    return;
  }

  e.preventDefault();
  e.stopPropagation();

  const formEl = e.currentTarget.closest('form');
  const productFormEl = formEl.closest('convermax-product-form');
  const submitBtn = formEl.querySelector('[name="add"]');

  // remove old error if has
  productFormEl?.setErrorMsgState?.();

  submitBtn?.setAttribute('aria-disabled', 'true');
  submitBtn?.classList.add('is-loading');

  const redirectPath = isFront
    ? `${pathname}?FrontProductID/${productId}/${window.Convermax.getVehicleSearchParams()}`
    : `${pathname}?RearProductID/${productId}/${window.Convermax.getVehicleSearchParams()}`;

  const { add: cartAdd, root: cartRoot } = window.Convermax.Shopify.getCartUrls();

  fetch(`${cartAdd}.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      items: [
        {
          id: variantId,
          quantity: +(formEl.querySelector('input[name="quantity"][type="number"]')?.value ?? 2),
        },
      ],
    }),
  })
    .then(async (addRes) => {
      if (addRes.ok) {
        window.location.replace(redirectPath);
        return;
      }

      const data = await addRes.json().catch(() => null);

      return fetch(`${cartRoot}.js`)
        .then((r) => r.json())
        .then((cart) => {
          const alreadyInCart = cart?.items?.some((i) => i.variant_id === Number(variantId));
          if (alreadyInCart) {
            window.location.replace(redirectPath);
            return;
          }

          let msg =
            (typeof data?.description === 'string' && data.description) ||
            (typeof data?.message === 'string' && data.message) ||
            null;

          if (msg?.includes('cart due to availability') && selectedStorePhone) {
            msg = `We don't have that many on hand. Give your store a call at ${selectedStorePhone} and we'll track them down for you.`;
          }

          if (data?.errors && typeof data.errors === 'object') {
            const list = Object.values(data.errors).flat().map(String);
            msg = list.length ? list.join(', ') : msg;
          }

          productFormEl.setErrorMsgState(msg || 'Could not add to cart. Please try again.');
        });
    })
    .catch((err) => {
      window.console.log(err);
      productFormEl.setErrorMsgState('Could not add to cart. Please try again.');
    })
    .finally(() => {
      submitBtn?.classList.add('is-success');
      submitBtn?.removeAttribute('aria-disabled');
      setTimeout(() => {
        submitBtn?.classList.remove('is-loading', 'is-success');
      }, 1400);
    });
};

function onVerifyFitmentResponseReceived(response) {
  const visualizationContainer = window.document.querySelector('#cm-autosync-preview');
  if (visualizationContainer) {
    const item = response?.Items?.[0];
    const isAutoSyncAllowed = item?.is_autosync_allowed;
    const fits = item?.fitsTheVehicle;

    if (!isAutoSyncAllowed || !fits || fits !== 'yes') {
      visualizationContainer.classList.add('cm_hide');
      return;
    }

    if (!visualizationContainer.classList.contains('cm_view-on-vehicle-btn')) {
      visualizationContainer.innerHTML = window.Convermax.translations?.view_product_on_vehicle ?? '';
      visualizationContainer.classList.add('cm_view-on-vehicle-btn', 'btn', 'cm_btn--secondary');
      visualizationContainer.addEventListener('click', () =>
        window.Convermax.openAutoSyncDialog(
          item.autosync_id,
          item.autosync_mpn,
          item.FitmentType?.includes('Tire'),
        ),
      );
    }

    visualizationContainer.classList.remove('cm_hide');
  }
}

const InitFunc = () => {
  shopifyEnterpriseGenericDefaults.InitFunc?.();
  if (!window.customElements.get('convermax-product-form')) {
    window.customElements.define('convermax-product-form', ConvermaxProductForm);
  }

  initYmmTabs({
    baseFitmentFields,
    tiresFields,
    wheelsFields,
    searchPageUrl,
  });
};

function getInitPreselection() {
  return getYmmTabPreselection({
    tiresFields,
    wheelsFields,
    tiresCollectionUrl,
    wheelsCollectionUrl,
    searchPageUrl,
  });
}

const vehicleSelectionShouldNotBeLoaded = () => {
  return (
    window.location.search &&
    (wheelsFields.some((f) => window.location.search.includes(f)) ||
      tiresFields.some((f) => window.location.search.includes(f)))
  );
};

export default {
  includes: ['shopify-enterprise-generic'],
  ...shopifyEnterpriseGenericDefaults,
  InitFunc,
  getInitPreselection,
  responseHandler,
  // because the tabs on search results trigger filters discarding
  disableRequestScroll: true,
  infiniteScrollEnabled: false,
  pagination: {
    centralRange: window.innerWidth <= 1024 ? 1 : 2,
    edgeRange: 1,
  },
  SearchRequestDefaults: {
    ...shopifyEnterpriseGenericDefaults.SearchRequestDefaults,
    pageSize: 20,
    extra: isOnCategoryListPage
      ? { ...defaultRequestExtra, formatWheelTireInfo: true }
      : { ...defaultRequestExtra },
  },
  autocomplete: {
    requestDefaults: {
      extra: { ...defaultRequestExtra, isAutoCompleteRequest: true },
    },
  },
  product: {
    ...shopifyEnterpriseGenericDefaults.product,
    searchResultsImageWidth: 500,
    searchResultsImageHeight: 500,
  },
  fitmentSearch: {
    ...shopifyEnterpriseGenericDefaults.fitmentSearch,
    forceVehicleSelection:
      isOnCategoryListPage || !!shopifyEnterpriseGenericDefaults.fitmentSearch.forceVehicleSelection,
    isAutoVehicleSelectionDisabled: window.Convermax?.Shopify?.pageType === 'index',
    onVerifyFitmentResponseReceived,
    onVerifyFitmentInitResponseReceived: onVerifyFitmentResponseReceived,
    onVehicleSelected: () => {
      ymmTabsOnVehicleSelected();
    },
    doNotLoadSelectedVehicle: vehicleSelectionShouldNotBeLoaded(),
  },
  facets: {
    ...shopifyEnterpriseGenericDefaults.facets,
    toggleFacet: [{ fields: ['on_deal'], term: 'True' }],
  },
  Widgets: [
    ...shopifyEnterpriseGenericDefaults.Widgets.filter(
      (w) =>
        ![
          'SearchResult',
          'SearchHeader',
          'Facets',
          'SearchVehicleWidget',
          'FacetCategoryTiles',
          'FacetBrandTiles',
          'VehicleWidgetDialog',
          'VerifyFitment',
          'Garage',
          'MobileGarage',
          'FacetBarWheels',
          'FacetBarTires',
          'VehicleSpecs',
          'HomeVehicleWidget_tab',
          'TirePanel_tab',
          'WheelPanel_tab',
        ].includes(w.name),
    ),
    {
      name: 'SearchResult',
      infiniteScrollDisabled: !!window.Convermax.config?.infiniteScrollDisabled,
      instantInfiniteScroll: !!window.Convermax.config?.instantInfiniteScroll,
      updateCallback,
    },
    {
      name: 'SearchHeader',
      facetToggleConfig: {
        toggledFacet: { field: 'on_deal', term: 'True' },
      },
    },
    {
      name: 'Facets',
      type: 'FacetPanel',
      ignoreFields: shopifyEnterpriseGenericDefaults.Widgets.find((w) => w.name === 'Facets').ignoreFields,
      initCollapsed: true,
      initExpandedFacets: ['Inventory'],
    },
    {
      name: 'HeaderVehicleWidget_tab',
      type: 'VehicleWidget',
      location: {
        selector: '#vehicle-ymm-tabs .cm-home-ymm',
        class: 'cm_vehicle-widget__tabs',
      },
      template: 'fitmentSearch/homeVehicleWidget',
      columnBreakpoint: 700,
      doNotRedirectOnVehicleSelect: !isOnHomePage,
      redirectUrl: tiresCollectionUrl,
      isVehicleSelectionIsolated: true,
    },
    {
      name: 'HeaderVehicleWidget_dialog-tab',
      type: 'VehicleWidget',
      location: {
        selector: '#location-vehicle-ymm-tabs .cm-home-ymm',
        class: 'cm_vehicle-widget__tabs cm_vehicle-widget__tabs--dialog',
      },
      template: 'fitmentSearch/homeVehicleWidget',
      columnBreakpoint: 700,
      doNotRedirectOnVehicleSelect: !isOnHomePage,
      redirectUrl: tiresCollectionUrl,
      isVehicleSelectionIsolated: true,
    },
    {
      name: 'TirePanel_tab',
      type: 'RequestPanel',
      location: {
        selector: '#vehicle-ymm-tabs .cm-home-tire',
        class: 'cm_vehicle-widget__tabs',
      },
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      isAutoRedirectDisabled: true,
      redirectUrl: isOnHomePage ? tiresCollectionUrl : window.location.pathname,
      selectFields: tiresFields,
      requiredFields: tiresFields,
      localStorageKey: 'cm_tire-tab-selection',
      shouldBeIsolated: () => !isAllProductsTires(),
    },
    {
      name: 'LocationDialogTirePanel_tab',
      type: 'RequestPanel',
      location: {
        selector: '#location-vehicle-ymm-tabs .cm-home-tire',
        class: 'cm_vehicle-widget__tabs cm_vehicle-widget__tabs--dialog',
      },
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      isAutoRedirectDisabled: true,
      redirectUrl: isOnHomePage ? tiresCollectionUrl : window.location.pathname,
      selectFields: tiresFields,
      requiredFields: tiresFields,
      localStorageKey: 'cm_tire-tab-selection',
      shouldBeIsolated: () => !isAllProductsTires(),
    },
    {
      name: 'WheelPanel_tab',
      type: 'RequestPanel',
      location: {
        selector: '#vehicle-ymm-tabs .cm-home-wheel',
        class: 'cm_vehicle-widget__tabs',
      },
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      redirectUrl: isOnHomePage ? wheelsCollectionUrl : window.location.pathname,
      isAutoRedirectDisabled: true,
      selectFields: wheelsFields,
      requiredFields: wheelsFields,
      localStorageKey: 'cm_wheel-tab-selection',
      shouldBeIsolated: () => !isAllProductsWheels(),
    },
    {
      name: 'LocationDialogWheelPanel_tab',
      type: 'RequestPanel',
      location: {
        selector: '#location-vehicle-ymm-tabs .cm-home-wheel',
        class: 'cm_vehicle-widget__tabs cm_vehicle-widget__tabs--dialog',
      },
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      redirectUrl: isOnHomePage ? wheelsCollectionUrl : window.location.pathname,
      isAutoRedirectDisabled: true,
      selectFields: wheelsFields,
      requiredFields: wheelsFields,
      localStorageKey: 'cm_wheel-tab-selection',
      shouldBeIsolated: () => !isAllProductsWheels(),
    },
    {
      name: 'UpsizeDownsizeFacetPanel',
      type: 'FacetPanel',
      fields: upsizeDownsizeFacetPanelFields,
      showAllAlways: true,
      disableCollapse: true,
    },
    {
      name: 'WheelTireVehicleInfo',
      useAutoSyncVisualizer: true,
    },
    {
      name: 'CategoryListPage',
      type: 'SearchPage',
      location: '#cm-collection-list',
      template: 'CategoryListPage',
    },
    {
      name: 'FacetCategoryTiles',
      type: 'FacetTiles',
      columnBreakpoint: 600,
      isVehicleWidgetDisabled: true,
    },
    {
      name: 'FacetBrandTiles',
      type: 'FacetTiles',
      location: '#cm-brand-list',
      template: 'facetTiles/alphabeticalContainer',
      columnBreakpoint: 600,
      isVehicleWidgetDisabled: !!window.document.querySelector('#cm-ymm'),
      facetField: 'Brand',
      view: 'grid',
    },
    {
      name: 'VehicleWidgetDialog',
      location: { class: 'vehicle-dialog' },
      template: 'fitmentSearch/dialog',
      doNotRedirectOnVehicleSelect: !isOnHomePage,
      fields:
        !!window.Convermax.config?.extraFieldsAsFilters &&
        shopifyEnterpriseGenericDefaults.fitmentSearch.baseFields,
    },
    {
      name: 'VerifyFitment',
      location: '#cm-verify-fitment',
      template: 'fitmentSearch/verifyFitment',
    },
    {
      name: 'Garage',
      location: {
        selector: '#cm-garage',
        class: 'header__icon',
      },
      template: 'fitmentSearch/garage',
      doNotRedirectOnVehicleSelect: !isOnHomePage,
      redirectUrl: isOnHomePage ? tiresCollectionUrl : null,
      useVehicleWidget: true,
    },
    {
      name: 'MobileGarage',
      type: 'Garage',
      location: '#cm-mobile-garage',
      template: 'fitmentSearch/garage',
      doNotRedirectOnVehicleSelect: !isOnHomePage,
      redirectUrl: isOnHomePage ? tiresCollectionUrl : null,
      useVehicleWidget: true,
    },
  ],
};
